import React, {useEffect, useState} from "react";
import {useStyles} from "./styles/FAQStyle";
import {Box, Button, Card, FormControlLabel, Modal, Switch, Tab, Tabs, TextField, Typography} from "@material-ui/core";
import clsx from "clsx";
import {ReactComponent as TranslationRefreshIcon} from '../../../common/images/TranslationRefreshIcon.svg';
import {inject, observer} from "mobx-react";
import {FAQLangName} from "../../../common/enums/ContentEnum";
import TabPanel from "../../../components/TabPanel";
import {faqType} from "../../../stores/FAQStore";
import {faqEnum} from "../../../common/enums/FAQEnum";
import {ReactComponent as ArrowLeftIcon} from "../../../common/images/ArrowLeftIcon.svg";
import {useHistory} from "react-router-dom";
import {URL_TYPE} from "../../../routes/Routes";
import {injectIntl} from "react-intl";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function FAQDetail(props) {
    const classes = useStyles();
    const {faqStore, localeStore} = props;
    const history = useHistory();
    const [type, setType] = React.useState(0);
    const [currentTab, setCurrentTab] = React.useState(faqType.question.name);
    const {intl} = props;
    const faqId = props.match.params.faqId;
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        if (faqId > 0) {
            faqStore.getFaqContents(faqId,faqStore.setFaqContents);
        }
        return ()=> {
            faqStore.initFAQDetailInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeTab = (event, newValue) =>{
        setType(newValue);
        const tabName = newValue === faqType.question.value ? faqType.question.name : faqType.answer.name;
        setCurrentTab(tabName);
    }

    const onSaveFAQ = () => {
        faqStore.addFAQList(faqId,gobackToList)
    }

    const handleChangeText = (lang,event) => {
        const index = faqStore.getCurrentIndexWithLangCode(lang);
        faqStore.setFAQElement(index,currentTab,event.target.value);
    }

    const handleChangeEnable = async (checked,languageCode=null) => {
        const isEnable = checked ? 'Y' : 'N';
        if (faqId > 0) {
            faqStore.updateFAQEnable(faqId,languageCode,isEnable,updateUICheck);
        } else {
            updateUICheck(languageCode,isEnable);
        }
    }

    const updateUICheck = (languageCode,isEnabled) => {
        if (languageCode) {
            const index = faqStore.getCurrentIndexWithLangCode(languageCode);
            faqStore.setFAQElement(index,faqEnum.isEnable,isEnabled);
        } else {
            faqStore.controlAllFAQEnable(isEnabled);
        }
    }

    const translateAll = () => {
        const lang  = props.match.params.lang;
        const text = faqStore.faqContents[faqStore.getCurrentIndexWithLangCode(props.match.params.lang)][currentTab];
        faqStore.translateAllFAQ(lang,text,currentTab,faqStore.setFaqTranslations);
    }


    const handleRefreshTranslationText = (translation,index) => {
        const languageCode = translation.languageCode;
        const text = faqStore.faqContents[faqStore.getCurrentIndexWithLangCode(props.match.params.lang)][currentTab]
        faqStore.translateFAQ(index,languageCode,props.match.params.lang,text,currentTab,faqStore.setFAQElement)
    }

    const gobackToList = () => {
        history.push(URL_TYPE.FAQ);
    }

    const handleDeleteFAQ = async () => {
        await faqStore.deleteFAQ(faqId);
        setOpenAlert(false);
        history.push(`/faq`);
    }

    const handleOpenDelete = () => {
        setOpenAlert(true);
    };

    const handleCloseDelete = () => {
        setOpenAlert(false);
    };

    const translationTabs = () => {
        return (
            <Box className={classes.headerArea} >
                <Box position="static" className={classes.tabBox} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Tabs value={type} onChange={changeTab} aria-label="simple tabs example">
                        <Tab label={faqType.question.name} {...a11yProps(0)} disableRipple/>
                        <Tab label={faqType.answer.name} {...a11yProps(1)} disableRipple/>
                    </Tabs>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} style={{padding: 0}}>
                        <FormControlLabel
                            style={{marginLeft:17}}
                            control={<Switch checked={faqStore.isAllFAQEnable} onChange={(event, checked) => handleChangeEnable(checked)} name="checkedB" className={classes.swichStyle}/>}
                            label={intl.formatMessage({id: "AppAllDisplayed"})}
                            labelPlacement="start"
                        />
                    </Box>
                </Box>
            </Box>
        )
    }

    const translationMainTextArea = () => {
        const disabled = !faqStore.faqContents[faqStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase())][currentTab].trim();
       return Object.values(faqType).map((el,index)=>(
            <TabPanel key={index} value={type} index={index} >
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} style={{width:'10%'}} paddingTop={1} >
                        <Typography className={classes.langText}>{FAQLangName[localeStore.locale.toUpperCase()][localeStore.locale.toUpperCase()]}</Typography>
                    </Box>
                    <Box>
                        <FormControlLabel
                            control={<Switch checked={(faqStore.faqContents[faqStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase())].isEnable === 'Y') || faqStore.isAllFAQEnable } onChange={(event,checked) => handleChangeEnable(checked,localeStore.locale.toUpperCase())} name="checkedB" className={classes.swichStyle}/>}
                            label={intl.formatMessage({id: "AppDisplayed"})}
                            labelPlacement="start"
                        />
                    </Box>
                </Box>
                <Box className={clsx(classes.textBox, classes.textBoxTranslation)}>
                    <Box>
                        <TextField
                            id="outlined-multiline-static"
                            multiline
                            minrows={4}
                            placeholder={intl.formatMessage({id: "TextPlaceholder"})}
                            variant="outlined"
                            value={faqStore.faqContents[faqStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase())][el.name]}
                            onChange={(e)=>handleChangeText(localeStore.locale.toUpperCase(),e)}
                        />
                    </Box>
                </Box>
                <Box className={classes.translateButtonArea}>
                    <Box>
                        <Button
                            disabled={disabled}
                            style={{borderColor: disabled ? 'gray' :'#7445FF'}}
                            variant={'outlined'}
                            onClick={translateAll}
                        >
                            <Typography style={{color:disabled ? 'gray' : '#7445FF'}}>{intl.formatMessage({id: "translation"})}</Typography>
                        </Button>
                    </Box>
                </Box>
            </TabPanel>
        ))
    }

    const translatingBox = (translation,index) => {
        const languageCode = translation.languageCode;
        return (
            <React.Fragment key={index}>
                {faqStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase()) !== index &&
                    <div key={index}>
                        <Box display={'flex'} justifyContent={'space-between'} className={classes.translationTitle}>
                            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} style={{width:'10%'}} paddingTop={1} >
                                <Typography className={classes.langText}>{FAQLangName[localeStore.locale.toUpperCase()][languageCode]}</Typography>
                                <Button disableRipple onClick={() => handleRefreshTranslationText(translation,index)}>
                                    <TranslationRefreshIcon/>
                                </Button>
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={<Switch checked={(translation.isEnable === 'Y') || faqStore.isAllFAQEnable } onChange={(event,checked) => handleChangeEnable(checked,languageCode)} name="checkedB" className={classes.swichStyle}/>}
                                    label={intl.formatMessage({id: "AppDisplayed"})}
                                    labelPlacement="start"
                                />
                            </Box>
                        </Box>
                        <Box>
                            <TextField
                                id="outlined-multiline-static"
                                multiline
                                minRows={4}
                                placeholder={intl.formatMessage({id: "TextPlaceholder"})}
                                variant="outlined"
                                value={translation[currentTab]}
                                onChange={(event) => handleChangeText(languageCode, event)}
                            />
                        </Box>
                    </div>
                }
            </React.Fragment>
        )
    }

    const bottomArea = () => {
        return (
            <Box className={classes.saveButtonArea}>
                <Box>
                    <Button variant={'text'} onClick={gobackToList}>
                        <ArrowLeftIcon />
                        <Typography>{intl.formatMessage({id: "List"})}</Typography>
                    </Button>
                </Box>
                <Box>
                    <Button disabled={!faqStore.isAllTranslationsFilled} style={{color:'white', backgroundColor:faqStore.isAllTranslationsFilled ? '#7445FF' : 'gray'}} variant={'contained'} onClick={onSaveFAQ}>
                        <Typography>{faqId === "0" ? intl.formatMessage({ id: "register" }) : intl.formatMessage({ id: "modify" })}</Typography>
                    </Button>
                </Box>
            </Box>
        )
    }

    return (
        <div className={classes.root}>
            {faqStore.faqContents.length > 0 &&
            <>
                {faqId !== "0" ? (
                    <Box marginRight={2} display={"flex"} justifyContent={"flex-end"} marginBottom={3}>
                        <Typography
                            style={{color: 'red', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer'}}
                            onClick={handleOpenDelete}>{intl.formatMessage({id: "delete"})}</Typography>
                        <Modal
                            open={openAlert}
                            onClose={handleCloseDelete}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box>
                                <Card style={{
                                    width: '380px',
                                    height: '200px',
                                    backgroundColor: "white",
                                    border: '1px solid black',
                                }}>
                                    <Box display={"flex"} flexDirection={"column"}>
                                        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"}
                                             textAlign={"center"} marginTop={5} marginBottom={5}>
                                            <Typography>{intl.formatMessage({id: "msg_info_delete1"})}</Typography>
                                            <Typography>{intl.formatMessage({id: "msg_info_delete2"})}</Typography>
                                        </Box>
                                        <Box display={"flex"} flexDirection={"row"} justifyContent={"center"}>
                                            <Box display={"flex"} justifyContent={"center"}>
                                                <Button className={classes.setButton1} disableRipple
                                                        onClick={handleCloseDelete}>
                                                    <Typography>{intl.formatMessage({id: "cancel"})}</Typography>
                                                </Button>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"center"}>
                                                <Button className={classes.setButton2} disableRipple
                                                    onClick={handleDeleteFAQ}>
                                                    <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Card>
                            </Box>
                        </Modal>
                    </Box>
                ) : null}
                <Box className={clsx(classes.boxWrap)}>
                    {translationTabs()}
                    {translationMainTextArea()}
                </Box>
                <Box className={classes.boxBottomTranslation}>
                    {faqStore.faqContents.length > 0 && faqStore.faqContents.map((list, index) => {
                        if (list.languageCode !== localeStore.locale.toUpperCase()) {
                            return translatingBox(list, index);
                        } else {
                            return null;
                        }
                    })}
                </Box>
                {bottomArea()}
            </>
            }
        </div>
    );
};


export default inject('faqStore', 'localeStore')(injectIntl(observer(FAQDetail)));
